export default {
   /* eslint-disable key-spacing */
   11: 'Menunggu verifikasi persyaratan',
   50: 'Izin terbit/SS terverifikasi',
   51: 'Masih Berlaku',
   58: 'Terbit Otomatis',
   99: 'Belum melengkapi persyaratan',
   /* eslint-enable key-spacing */
}
